import React from 'react';
import Footer from './Footer';

const AboutPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8 min-h-screen">
      <div className="max-w-5xl mx-auto bg-white shadow-xl rounded-xl p-6 sm:p-10">
        <h1 className="text-4xl sm:text-5xl font-bold text-center text-gray-800 mb-8 leading-tight">
          About Us
        </h1>

        <h2 className="text-xl sm:text-2xl font-semibold text-primary-600 mb-4">
          Reimagining Financial Advice for Every Indian Investor
        </h2>
        <p className="text-gray-700 mb-4 leading-relaxed">
          In India, investment advice often comes as a WhatsApp “tip” from a friend or a well-meaning uncle, pointing you toward a hot stock, mutual fund, or the latest tax-saving scheme. More than 90% of individuals believe they do not need a financial advisor and are confident they can manage their own finances successfully.
        </p>
        <p className="text-gray-700 mb-4 leading-relaxed">
          However, the reality is that navigating the complexities of taxes, investments, and financial planning requires expert guidance—especially as your needs evolve over time.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed">
          Yet, the real challenge is even deeper: finding credible, personalized guidance is daunting. The financial advisory landscape is fragmented, trust is eroded by commission-based selling, and for most investors, it’s nearly impossible to verify an advisor’s credentials or track record.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold text-primary-600 mb-4">
          Our Mission: Trusted Financial Guidance, Made Accessible
        </h2>
        <p className="text-gray-700 mb-6 leading-relaxed">
          Our mission is to ensure that every individual has access to the right financial advice, tailored to their unique needs at every stage of life. Whether you’re starting your career, building a family, planning for your child’s education, or preparing for retirement, your financial goals and challenges evolve—and so should your guidance.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed">
          We are dedicated to breaking down the barriers that make finding trustworthy, personalized financial advice difficult. By connecting you with verified, expert advisors across all areas of personal finance—tax, investments, insurance, estate planning, and more—we aim to make quality financial guidance accessible, transparent, and convenient for everyone, regardless of location or life stage.
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold text-primary-600 mb-4">
          Our Solution: A Marketplace Built on Trust and Transparency
        </h2>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-3 leading-relaxed">
          <li>
            <strong>Verified Advisors Only:</strong> Every advisor on our platform is vetted for credentials, regulatory compliance, and track record. We verify SEBI registration and ensure transparent fee structures—no hidden commissions.
          </li>
          <li>
            <strong>Tailored Discovery:</strong> Advanced filters help you find advisors by specialization, experience, fees, location, and client ratings, so you can choose the right fit for your unique needs.
          </li>
          <li>
            <strong>Accessible to All:</strong> No matter where you are—big city or small town—you can access quality advice without high minimum investment requirements or geographic barriers.
          </li>
        </ul>

        <h2 className="text-xl sm:text-2xl font-semibold text-primary-600 mb-4">
          Our Vision
        </h2>
        <p className="text-gray-700 mb-6 leading-relaxed">
          We’re on a mission to democratize access to quality financial advice for every Indian investor. By combining technology, transparency, and a rigorous vetting process, we aim to empower you to make smarter financial decisions—at every stage of your journey.
        </p>

        <p className="text-gray-800 font-medium text-center text-lg sm:text-xl">
          Join us as we build a future where trusted financial guidance is just a click away.
        </p>
      </div>
      <Footer/>
    </div>
  );
};

export default AboutPage;
